import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionsRegistryService } from "@sdbn/common-extended";
import { CarrierConditionEditorComponent } from './carrier-condition-editor/carrier-condition-editor.component'
import { ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, TranslationService } from "@sdbn/common";
import { String1ConditionEditorComponent } from './string-1-condition-editor/string-1-condition-editor.component';
import { String2ConditionEditorComponent } from './string-2-condition-editor/string-2-condition-editor.component';
import { ReferenceConditionEditorComponent } from './reference-condition-editor/reference-condition-editor.component';
import { TransportTypeConditionEditorComponent } from './transport-type-condition-editor/transport-type-condition-editor.component';
import { TransportScopeConditionEditorComponent } from './transport-scope-condition-editor/transport-scope-condition-editor.component';
import { CargoInPositionConditionEditorComponent } from './cargo-in-position-condition-editor/cargo-in-position-condition-editor.component';
import { TransportStatusConditionEditorComponent } from './transport-status-condition-editor/transport-status-condition-editor.component';
import { TransportOptionConditionEditorComponent } from './transport-option-condition-editor/transport-option-condition-editor.component';
import { TmcContextService } from '../../common/tmc-context.service';
import { Subscription } from 'rxjs';
import { TransportOption } from '../../client/model/transport-option';
import { StructureSelectionModule } from '../../common/structure-selection/structure-selection.module';
import { TaskTypeConditionEditorComponent } from './task-type-condition-editor/task-type-condition-editor.component';
import { Task } from '../../client/model/yard-configuration';
import { ProcessingModuleConditionEditorComponent } from './processing-status-condition-editor/processing-status-condition-editor.component';
import { ProcessingStatusModel } from '../../client/model/processing-status-model';


@NgModule({
  declarations: [
    CarrierConditionEditorComponent,
    String1ConditionEditorComponent,
    String2ConditionEditorComponent,
    ReferenceConditionEditorComponent,
    TransportTypeConditionEditorComponent,
    TransportScopeConditionEditorComponent,
    CargoInPositionConditionEditorComponent,
    TransportStatusConditionEditorComponent,
    TransportOptionConditionEditorComponent,
    TaskTypeConditionEditorComponent,
    ProcessingModuleConditionEditorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    StructureSelectionModule
  ]
})
export class TransportConditionsModule {

  tmcContextSubscription: Subscription;
  transportOptions = new Array<TransportOption>();
  tasks = new Array<Task>();
  processingStatusModels: ProcessingStatusModel[];

  constructor(
    private conditionsRegistryService: ConditionsRegistryService,
    private translationService: TranslationService,
    private tmcContextService: TmcContextService
  ) {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        let transportOptions = new Array<TransportOption>();
        for (const to of tmcContextService.getYardConfiguration().transportOptions) {
          transportOptions.push(to);
          for (const childTo of to.transportOptions) {
            transportOptions.push(childTo);
          }
        }

        this.tasks = tmcContextService.getYardConfiguration().tasks;

        this.processingStatusModels = this.tmcContextService.getYardConfiguration().processingStatusModels;
      }
    });

    this.conditionsRegistryService.registerTemplateGroup({
      titleDictionaryKey: 'tmc-yard.ui.conditions.transport-masterdata',
      anchors: ['transport'],
      templates: [
        {
          titleDictionaryKey: 'tmc-yard.entity.transport.masterdata.carrier',
          key: 'transport-carrier',
          iconCss: 'fa-cog',
          editor: CarrierConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data)
        },
        {
          titleDictionaryKey: 'tmc-yard.entity.transport.masterdata.string1',
          key: 'transport-string-1',
          iconCss: 'fa-cog',
          editor: String1ConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data)
        },
        {
          titleDictionaryKey: 'tmc-yard.entity.transport.masterdata.string2',
          key: 'transport-string-2',
          iconCss: 'fa-cog',
          editor: String2ConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data)
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.transport-option',
          key: 'transport-option',
          iconCss: 'fa-cog',
          editor: TransportOptionConditionEditorComponent,
          summaryProvider: (data: string, language: string) => {
            let id = Number(data);
            let to = this.transportOptions.find(to => to.id === id);
            return Promise.resolve(to ? translationService.translate(to.nameDictionaryKey) : '');
          }
        },
        {
          titleDictionaryKey: 'tmc-yard.entity.transport.masterdata.important',
          key: 'transport-important',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.entity.transport.status',
          key: 'transport-status',
          iconCss: 'fa-cog',
          editor: TransportStatusConditionEditorComponent,
          summaryProvider: (data: string, language: string) => {
            let result = '';
            if (data) {
              for (let key of data.split(',')) {
                if (result != '') {
                  result += ', ';
                }
                result += translationService.translate('tmc-yard.common.enum.transport-processing-status.' + key);
              }
            }
            return Promise.resolve(result);
          }
        },
        {
          titleDictionaryKey: 'tmc-yard.common.type',
          key: 'transport-type',
          iconCss: 'fa-cog',
          editor: TransportTypeConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data ? translationService.translate('tmc-yard.entity.transport.transport-type.' + data) : '')
        },
        {
          titleDictionaryKey: 'tmc-yard.entity.transport.masterdata.firstLoadCarrier.orderReference',
          key: 'transport-order-reference',
          iconCss: 'fa-cog',
          editor: ReferenceConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data)
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.transport-scope',
          key: 'transport-scope',
          iconCss: 'fa-cog',
          editor: TransportScopeConditionEditorComponent,
          summaryProvider: (data: string, language: string) => {
            let result = '';
            for (let key of data.split(',')) {
              if (result != '') {
                result += ', ';
              }
              result += translationService.translate('tmc-yard.entity.transport.transport-scope.' + key);
            }
            return Promise.resolve(result);
          }
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.cargo-in-positions',
          key: 'transport-cargo-in-position',
          iconCss: 'fa-cog',
          editor: CargoInPositionConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data)
        }
      ]
    });

    this.conditionsRegistryService.registerTemplateGroup({
      titleDictionaryKey: 'tmc-yard.ui.conditions.transport-processing',
      anchors: ['transport'],
      templates: [
        {
          titleDictionaryKey: 'tmc-yard.filter-administration.ui.filter-conditions.withoutRouting',
          key: 'transport-without-routing',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.processing-status',
          key: 'transport-processing-status',
          iconCss: 'fa-cog',
          editor: ProcessingModuleConditionEditorComponent,
          summaryProvider: (data: string, language: string) => {
            let dataObject = JSON.parse(data);
            let model = this.processingStatusModels.find(pm => pm.key === dataObject['process']);
            if (!model) {
              return Promise.resolve('no status model available by id ' + dataObject['process']);
            }
            let step = model!.status.find(s => s.key === dataObject['processStep']);
            if (!step) {
              return Promise.resolve('no status available by id ' + dataObject['processStep']);
            }
            return Promise.resolve(translationService.translate(model.nameDictionaryKey) + ' - ' + translationService.translate(step.dictionaryKey));
          }
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.waiting-for-pulling',
          key: 'transport-waiting-for-pulling',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.finished',
          key: 'transport-finished',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.planned',
          key: 'transport-planned',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.intermitted',
          key: 'transport-intermitted',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.planned-in-next-24-hours',
          key: 'transport-planned-in-next-24-hours',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.filter-administration.ui.filter-conditions.planned-tomorrow',
          key: 'transport-planned-tomorrow',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.in-processing-or-planned-for-today',
          key: 'transport-in-processing-or-planned-for-today',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        }
      ]
    });

    this.conditionsRegistryService.registerTemplateGroup({
      titleDictionaryKey: 'tmc-yard.ui.conditions.transport-tasks',
      anchors: ['transport'],
      templates: [
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.has-no-tasks',
          key: 'transport-has-no-tasks',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.has-any-tasks',
          key: 'transport-has-any-task',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.has-blocking-tasks',
          key: 'transport-has-blocking-task',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.has-open-tasks-of-type',
          key: 'transport-has-open-task-of-type',
          iconCss: 'fa-cog',
          editor: TaskTypeConditionEditorComponent,
          summaryProvider: (data: string, language: string) => {
            let id = Number(data);
            let to = this.tasks.find(t => t.id === id);
            return Promise.resolve(to ? translationService.translate(to.nameDictionaryKey) : 'no data for id: ' + data);
          }
        }
      ]
    });

  }


}
